/**
 * Generato automaticamente.
 * framework-cmp-procedimenti
 */
import { useMutation, useQuery } from 'react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient.ts';
import type { ErrorType } from '../../../client/apiClient.ts';
import type { AnagraficaFasiDTO } from '../schemas/anagraficaFasiDTO.ts';
import type { BEResponseAttivitaDTO } from '../schemas/bEResponseAttivitaDTO.ts';
import type { BEResponseIstanzaProcedimentoDTO } from '../schemas/bEResponseIstanzaProcedimentoDTO.ts';
import type { BEResponseListCampoSemanticoProcedimento } from '../schemas/bEResponseListCampoSemanticoProcedimento.ts';
import type { BEResponseListProcedimento } from '../schemas/bEResponseListProcedimento.ts';
import type { BEResponseListTaskProcedimento } from '../schemas/bEResponseListTaskProcedimento.ts';
import type { BEResponseListTipologiaProcedimentoDTO } from '../schemas/bEResponseListTipologiaProcedimentoDTO.ts';
import type { BEResponseProcedimentoConOggettiCollegati } from '../schemas/bEResponseProcedimentoConOggettiCollegati.ts';
import type { BEResponseProcedimentoConTask } from '../schemas/bEResponseProcedimentoConTask.ts';
import type { BEResponseRicercaProcedimentoResponseDTO } from '../schemas/bEResponseRicercaProcedimentoResponseDTO.ts';
import type { BEResponseWsRispostaPaginataListCollegamentoIstanzaDettaglioDTO } from '../schemas/bEResponseWsRispostaPaginataListCollegamentoIstanzaDettaglioDTO.ts';
import type { CampoEstraibileCSV } from '../schemas/campoEstraibileCSV.ts';
import type { CampoSemanticoProcedimento } from '../schemas/campoSemanticoProcedimento.ts';
import type { ChiudiEndoprocedimentoRequest } from '../schemas/chiudiEndoprocedimentoRequest.ts';
import type { Competenza } from '../schemas/competenza.ts';
import type { CreaAllegatoResponse } from '../schemas/creaAllegatoResponse.ts';
import type { CreaEndoprocedimentoRequest } from '../schemas/creaEndoprocedimentoRequest.ts';
import type { CreaProcedimentoRequest } from '../schemas/creaProcedimentoRequest.ts';
import type { CreaScadenzaRequest } from '../schemas/creaScadenzaRequest.ts';
import type { ElencoFileDocumento } from '../schemas/elencoFileDocumento.ts';
import type { GetBackProcedimentiB2BParams } from '../schemas/getBackProcedimentiB2BParams.ts';
import type { GetBackProcedimentiB2BSearchParams } from '../schemas/getBackProcedimentiB2BSearchParams.ts';
import type { GetBackProcedimentiCsvCampiParams } from '../schemas/getBackProcedimentiCsvCampiParams.ts';
import type { GetBackProcedimentiGeojsonCampiParams } from '../schemas/getBackProcedimentiGeojsonCampiParams.ts';
import type { GetBackProcedimentiIdAnagraficaFasiParams } from '../schemas/getBackProcedimentiIdAnagraficaFasiParams.ts';
import type { GetBackProcedimentiIdCollegamentiParams } from '../schemas/getBackProcedimentiIdCollegamentiParams.ts';
import type { GetBackProcedimentiIdScadenzeParams } from '../schemas/getBackProcedimentiIdScadenzeParams.ts';
import type { GetBackProcedimentiParams } from '../schemas/getBackProcedimentiParams.ts';
import type { GetBackProcedimentiPraticaIdSoggettiParams } from '../schemas/getBackProcedimentiPraticaIdSoggettiParams.ts';
import type { GetBackProcedimentiPraticaIdVisibilitaParams } from '../schemas/getBackProcedimentiPraticaIdVisibilitaParams.ts';
import type { GetBackProcedimentiTipiAvviabiliParams } from '../schemas/getBackProcedimentiTipiAvviabiliParams.ts';
import type { GetBackProcedimentiTipiParams } from '../schemas/getBackProcedimentiTipiParams.ts';
import type { GetUfficioResponse } from '../schemas/getUfficioResponse.ts';
import type { IstanzaProcedimento } from '../schemas/istanzaProcedimento.ts';
import type { OggettiCollegatiResponse } from '../schemas/oggettiCollegatiResponse.ts';
import type { PersonaFisicaDTO } from '../schemas/personaFisicaDTO.ts';
import type { PersonaFisicaRequestDTO } from '../schemas/personaFisicaRequestDTO.ts';
import type { PostBackProcedimentiGeojson200 } from '../schemas/postBackProcedimentiGeojson200.ts';
import type { PostBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdAllegatiBody } from '../schemas/postBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdAllegatiBody.ts';
import type { PraticaDomandaDTO } from '../schemas/praticaDomandaDTO.ts';
import type { PraticaUfficioDTO } from '../schemas/praticaUfficioDTO.ts';
import type { PraticaUfficioLightDTO } from '../schemas/praticaUfficioLightDTO.ts';
import type { Procedimento } from '../schemas/procedimento.ts';
import type { RicercaProcedimentoCsvRequest } from '../schemas/ricercaProcedimentoCsvRequest.ts';
import type { ScadenzaDTO } from '../schemas/scadenzaDTO.ts';
import type { SubentroDTO } from '../schemas/subentroDTO.ts';
import type { TipoProcedimentoDettaglioUfficiAssociatiDTO } from '../schemas/tipoProcedimentoDettaglioUfficiAssociatiDTO.ts';
import type { VisibilitaRichiestaEndoprocedimentoDTO } from '../schemas/visibilitaRichiestaEndoprocedimentoDTO.ts';
import type { WsRispostaPaginataListScadenzaDTO } from '../schemas/wsRispostaPaginataListScadenzaDTO.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

export const putBackProcedimentiIdAvvia = (
  idTipoProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseAttivitaDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idTipoProcedimento}/avvia`,
      method: 'put',
    },
    options,
  );
};

export const getPutBackProcedimentiIdAvviaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBackProcedimentiIdAvvia>>,
    TError,
    { idTipoProcedimento: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putBackProcedimentiIdAvvia>>,
  TError,
  { idTipoProcedimento: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putBackProcedimentiIdAvvia>>,
    { idTipoProcedimento: string }
  > = props => {
    const { idTipoProcedimento } = props ?? {};

    return putBackProcedimentiIdAvvia(idTipoProcedimento, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutBackProcedimentiIdAvviaMutationResult = NonNullable<
  Awaited<ReturnType<typeof putBackProcedimentiIdAvvia>>
>;

export type PutBackProcedimentiIdAvviaMutationError = ErrorType<unknown>;

export const usePutBackProcedimentiIdAvvia = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBackProcedimentiIdAvvia>>,
    TError,
    { idTipoProcedimento: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPutBackProcedimentiIdAvviaMutationOptions(options);

  return useMutation(mutationOptions);
};
export const putBackProcedimentiIdAvviaDaRichiesta = (
  idTipoProcedimento: string,
  creaProcedimentoRequest: CreaProcedimentoRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseIstanzaProcedimentoDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idTipoProcedimento}/avviaDaRichiesta`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: creaProcedimentoRequest,
    },
    options,
  );
};

export const getPutBackProcedimentiIdAvviaDaRichiestaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBackProcedimentiIdAvviaDaRichiesta>>,
    TError,
    { idTipoProcedimento: string; data: CreaProcedimentoRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putBackProcedimentiIdAvviaDaRichiesta>>,
  TError,
  { idTipoProcedimento: string; data: CreaProcedimentoRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putBackProcedimentiIdAvviaDaRichiesta>>,
    { idTipoProcedimento: string; data: CreaProcedimentoRequest }
  > = props => {
    const { idTipoProcedimento, data } = props ?? {};

    return putBackProcedimentiIdAvviaDaRichiesta(
      idTipoProcedimento,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PutBackProcedimentiIdAvviaDaRichiestaMutationResult = NonNullable<
  Awaited<ReturnType<typeof putBackProcedimentiIdAvviaDaRichiesta>>
>;
export type PutBackProcedimentiIdAvviaDaRichiestaMutationBody =
  CreaProcedimentoRequest;
export type PutBackProcedimentiIdAvviaDaRichiestaMutationError =
  ErrorType<unknown>;

export const usePutBackProcedimentiIdAvviaDaRichiesta = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBackProcedimentiIdAvviaDaRichiesta>>,
    TError,
    { idTipoProcedimento: string; data: CreaProcedimentoRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPutBackProcedimentiIdAvviaDaRichiestaMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Ottiene il dettaglio di visibilità per l'endoprocedimento
 */
export const getBackProcedimentiIdEndoprocedimentiIdVisibilitaRichiesta = (
  idIstanzaProcedimento: string,
  idIstanzaEndoprocedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<VisibilitaRichiestaEndoprocedimentoDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/endoprocedimenti/${idIstanzaEndoprocedimento}/visibilita-richiesta`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdEndoprocedimentiIdVisibilitaRichiestaQueryKey =
  (idIstanzaProcedimento: string, idIstanzaEndoprocedimento: string) =>
    [
      `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/endoprocedimenti/${idIstanzaEndoprocedimento}/visibilita-richiesta`,
    ] as const;

export const getGetBackProcedimentiIdEndoprocedimentiIdVisibilitaRichiestaQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getBackProcedimentiIdEndoprocedimentiIdVisibilitaRichiesta
      >
    >,
    TError = ErrorType<unknown>,
  >(
    idIstanzaProcedimento: string,
    idIstanzaEndoprocedimento: string,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBackProcedimentiIdEndoprocedimentiIdVisibilitaRichiesta
          >
        >,
        TError,
        TData
      >;
      request?: SecondParameter<typeof apiClientRequest>;
    },
  ): UseQueryOptions<
    Awaited<
      ReturnType<
        typeof getBackProcedimentiIdEndoprocedimentiIdVisibilitaRichiesta
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey } => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetBackProcedimentiIdEndoprocedimentiIdVisibilitaRichiestaQueryKey(
        idIstanzaProcedimento,
        idIstanzaEndoprocedimento,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getBackProcedimentiIdEndoprocedimentiIdVisibilitaRichiesta
        >
      >
    > = ({ signal }) =>
      getBackProcedimentiIdEndoprocedimentiIdVisibilitaRichiesta(
        idIstanzaProcedimento,
        idIstanzaEndoprocedimento,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(idIstanzaProcedimento && idIstanzaEndoprocedimento),
      ...queryOptions,
    };
  };

export type GetBackProcedimentiIdEndoprocedimentiIdVisibilitaRichiestaQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getBackProcedimentiIdEndoprocedimentiIdVisibilitaRichiesta
      >
    >
  >;
export type GetBackProcedimentiIdEndoprocedimentiIdVisibilitaRichiestaQueryError =
  ErrorType<unknown>;

/**
 * @summary Ottiene il dettaglio di visibilità per l'endoprocedimento
 */
export const useGetBackProcedimentiIdEndoprocedimentiIdVisibilitaRichiesta = <
  TData = Awaited<
    ReturnType<
      typeof getBackProcedimentiIdEndoprocedimentiIdVisibilitaRichiesta
    >
  >,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  idIstanzaEndoprocedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getBackProcedimentiIdEndoprocedimentiIdVisibilitaRichiesta
        >
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetBackProcedimentiIdEndoprocedimentiIdVisibilitaRichiestaQueryOptions(
      idIstanzaProcedimento,
      idIstanzaEndoprocedimento,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Aggiorna il dettaglio di visibilità per l'endoprocedimento
 */
export const putBackProcedimentiIdEndoprocedimentiIdVisibilitaRichiesta = (
  idIstanzaProcedimento: string,
  idIstanzaEndoprocedimento: string,
  visibilitaRichiestaEndoprocedimentoDTO: VisibilitaRichiestaEndoprocedimentoDTO,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<VisibilitaRichiestaEndoprocedimentoDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/endoprocedimenti/${idIstanzaEndoprocedimento}/visibilita-richiesta`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: visibilitaRichiestaEndoprocedimentoDTO,
    },
    options,
  );
};

export const getPutBackProcedimentiIdEndoprocedimentiIdVisibilitaRichiestaMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof putBackProcedimentiIdEndoprocedimentiIdVisibilitaRichiesta
        >
      >,
      TError,
      {
        idIstanzaProcedimento: string;
        idIstanzaEndoprocedimento: string;
        data: VisibilitaRichiestaEndoprocedimentoDTO;
      },
      TContext
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof putBackProcedimentiIdEndoprocedimentiIdVisibilitaRichiesta
      >
    >,
    TError,
    {
      idIstanzaProcedimento: string;
      idIstanzaEndoprocedimento: string;
      data: VisibilitaRichiestaEndoprocedimentoDTO;
    },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof putBackProcedimentiIdEndoprocedimentiIdVisibilitaRichiesta
        >
      >,
      {
        idIstanzaProcedimento: string;
        idIstanzaEndoprocedimento: string;
        data: VisibilitaRichiestaEndoprocedimentoDTO;
      }
    > = props => {
      const { idIstanzaProcedimento, idIstanzaEndoprocedimento, data } =
        props ?? {};

      return putBackProcedimentiIdEndoprocedimentiIdVisibilitaRichiesta(
        idIstanzaProcedimento,
        idIstanzaEndoprocedimento,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PutBackProcedimentiIdEndoprocedimentiIdVisibilitaRichiestaMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof putBackProcedimentiIdEndoprocedimentiIdVisibilitaRichiesta
      >
    >
  >;
export type PutBackProcedimentiIdEndoprocedimentiIdVisibilitaRichiestaMutationBody =
  VisibilitaRichiestaEndoprocedimentoDTO;
export type PutBackProcedimentiIdEndoprocedimentiIdVisibilitaRichiestaMutationError =
  ErrorType<unknown>;

/**
 * @summary Aggiorna il dettaglio di visibilità per l'endoprocedimento
 */
export const usePutBackProcedimentiIdEndoprocedimentiIdVisibilitaRichiesta = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        typeof putBackProcedimentiIdEndoprocedimentiIdVisibilitaRichiesta
      >
    >,
    TError,
    {
      idIstanzaProcedimento: string;
      idIstanzaEndoprocedimento: string;
      data: VisibilitaRichiestaEndoprocedimentoDTO;
    },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPutBackProcedimentiIdEndoprocedimentiIdVisibilitaRichiestaMutationOptions(
      options,
    );

  return useMutation(mutationOptions);
};
export const putBackProcedimentiIdEndoprocedimentiIdChiudi = (
  idIstanzaProcedimento: string,
  idIstanzaEndoprocedimento: string,
  chiudiEndoprocedimentoRequest: ChiudiEndoprocedimentoRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseProcedimentoConTask>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/endoprocedimenti/${idIstanzaEndoprocedimento}/chiudi`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: chiudiEndoprocedimentoRequest,
    },
    options,
  );
};

export const getPutBackProcedimentiIdEndoprocedimentiIdChiudiMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBackProcedimentiIdEndoprocedimentiIdChiudi>>,
    TError,
    {
      idIstanzaProcedimento: string;
      idIstanzaEndoprocedimento: string;
      data: ChiudiEndoprocedimentoRequest;
    },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putBackProcedimentiIdEndoprocedimentiIdChiudi>>,
  TError,
  {
    idIstanzaProcedimento: string;
    idIstanzaEndoprocedimento: string;
    data: ChiudiEndoprocedimentoRequest;
  },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putBackProcedimentiIdEndoprocedimentiIdChiudi>>,
    {
      idIstanzaProcedimento: string;
      idIstanzaEndoprocedimento: string;
      data: ChiudiEndoprocedimentoRequest;
    }
  > = props => {
    const { idIstanzaProcedimento, idIstanzaEndoprocedimento, data } =
      props ?? {};

    return putBackProcedimentiIdEndoprocedimentiIdChiudi(
      idIstanzaProcedimento,
      idIstanzaEndoprocedimento,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PutBackProcedimentiIdEndoprocedimentiIdChiudiMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof putBackProcedimentiIdEndoprocedimentiIdChiudi>>
  >;
export type PutBackProcedimentiIdEndoprocedimentiIdChiudiMutationBody =
  ChiudiEndoprocedimentoRequest;
export type PutBackProcedimentiIdEndoprocedimentiIdChiudiMutationError =
  ErrorType<unknown>;

export const usePutBackProcedimentiIdEndoprocedimentiIdChiudi = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBackProcedimentiIdEndoprocedimentiIdChiudi>>,
    TError,
    {
      idIstanzaProcedimento: string;
      idIstanzaEndoprocedimento: string;
      data: ChiudiEndoprocedimentoRequest;
    },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPutBackProcedimentiIdEndoprocedimentiIdChiudiMutationOptions(options);

  return useMutation(mutationOptions);
};
export const putBackProcedimentiIdAggiornaDaRichiesta = (
  idIstanzaProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<void>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/aggiornaDaRichiesta`,
      method: 'put',
    },
    options,
  );
};

export const getPutBackProcedimentiIdAggiornaDaRichiestaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBackProcedimentiIdAggiornaDaRichiesta>>,
    TError,
    { idIstanzaProcedimento: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putBackProcedimentiIdAggiornaDaRichiesta>>,
  TError,
  { idIstanzaProcedimento: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putBackProcedimentiIdAggiornaDaRichiesta>>,
    { idIstanzaProcedimento: string }
  > = props => {
    const { idIstanzaProcedimento } = props ?? {};

    return putBackProcedimentiIdAggiornaDaRichiesta(
      idIstanzaProcedimento,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PutBackProcedimentiIdAggiornaDaRichiestaMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof putBackProcedimentiIdAggiornaDaRichiesta>>
  >;

export type PutBackProcedimentiIdAggiornaDaRichiestaMutationError =
  ErrorType<unknown>;

export const usePutBackProcedimentiIdAggiornaDaRichiesta = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBackProcedimentiIdAggiornaDaRichiesta>>,
    TError,
    { idIstanzaProcedimento: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPutBackProcedimentiIdAggiornaDaRichiestaMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getBackProcedimentiPraticaIdVisibilita = (
  idIstanzaProcedimento: string,
  params: GetBackProcedimentiPraticaIdVisibilitaParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<PraticaUfficioDTO[]>(
    {
      url: `/framework-bo-procedimenti/procedimenti/pratica/${idIstanzaProcedimento}/visibilita`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiPraticaIdVisibilitaQueryKey = (
  idIstanzaProcedimento: string,
  params: GetBackProcedimentiPraticaIdVisibilitaParams,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/pratica/${idIstanzaProcedimento}/visibilita`,
    ...(params ? [params] : []),
  ] as const;

export const getGetBackProcedimentiPraticaIdVisibilitaQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiPraticaIdVisibilita>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  params: GetBackProcedimentiPraticaIdVisibilitaParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiPraticaIdVisibilita>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiPraticaIdVisibilita>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiPraticaIdVisibilitaQueryKey(
      idIstanzaProcedimento,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiPraticaIdVisibilita>>
  > = ({ signal }) =>
    getBackProcedimentiPraticaIdVisibilita(
      idIstanzaProcedimento,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetBackProcedimentiPraticaIdVisibilitaQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiPraticaIdVisibilita>>
>;
export type GetBackProcedimentiPraticaIdVisibilitaQueryError =
  ErrorType<unknown>;

export const useGetBackProcedimentiPraticaIdVisibilita = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiPraticaIdVisibilita>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  params: GetBackProcedimentiPraticaIdVisibilitaParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiPraticaIdVisibilita>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiPraticaIdVisibilitaQueryOptions(
    idIstanzaProcedimento,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putBackProcedimentiPraticaIdVisibilita = (
  idIstanzaProcedimento: string,
  praticaUfficioLightDTO: PraticaUfficioLightDTO[],
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<PraticaUfficioDTO[]>(
    {
      url: `/framework-bo-procedimenti/procedimenti/pratica/${idIstanzaProcedimento}/visibilita`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: praticaUfficioLightDTO,
    },
    options,
  );
};

export const getPutBackProcedimentiPraticaIdVisibilitaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBackProcedimentiPraticaIdVisibilita>>,
    TError,
    { idIstanzaProcedimento: string; data: PraticaUfficioLightDTO[] },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putBackProcedimentiPraticaIdVisibilita>>,
  TError,
  { idIstanzaProcedimento: string; data: PraticaUfficioLightDTO[] },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putBackProcedimentiPraticaIdVisibilita>>,
    { idIstanzaProcedimento: string; data: PraticaUfficioLightDTO[] }
  > = props => {
    const { idIstanzaProcedimento, data } = props ?? {};

    return putBackProcedimentiPraticaIdVisibilita(
      idIstanzaProcedimento,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PutBackProcedimentiPraticaIdVisibilitaMutationResult = NonNullable<
  Awaited<ReturnType<typeof putBackProcedimentiPraticaIdVisibilita>>
>;
export type PutBackProcedimentiPraticaIdVisibilitaMutationBody =
  PraticaUfficioLightDTO[];
export type PutBackProcedimentiPraticaIdVisibilitaMutationError =
  ErrorType<unknown>;

export const usePutBackProcedimentiPraticaIdVisibilita = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBackProcedimentiPraticaIdVisibilita>>,
    TError,
    { idIstanzaProcedimento: string; data: PraticaUfficioLightDTO[] },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPutBackProcedimentiPraticaIdVisibilitaMutationOptions(options);

  return useMutation(mutationOptions);
};
export const putBackProcedimentiPraticaIdTipiProcedimentoIdAvvia = (
  idIstanzaProcedimento: string,
  idTipoProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseAttivitaDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/pratica/${idIstanzaProcedimento}/tipi-procedimento/${idTipoProcedimento}/avvia`,
      method: 'put',
    },
    options,
  );
};

export const getPutBackProcedimentiPraticaIdTipiProcedimentoIdAvviaMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof putBackProcedimentiPraticaIdTipiProcedimentoIdAvvia>
      >,
      TError,
      { idIstanzaProcedimento: string; idTipoProcedimento: string },
      TContext
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof putBackProcedimentiPraticaIdTipiProcedimentoIdAvvia>
    >,
    TError,
    { idIstanzaProcedimento: string; idTipoProcedimento: string },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof putBackProcedimentiPraticaIdTipiProcedimentoIdAvvia>
      >,
      { idIstanzaProcedimento: string; idTipoProcedimento: string }
    > = props => {
      const { idIstanzaProcedimento, idTipoProcedimento } = props ?? {};

      return putBackProcedimentiPraticaIdTipiProcedimentoIdAvvia(
        idIstanzaProcedimento,
        idTipoProcedimento,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PutBackProcedimentiPraticaIdTipiProcedimentoIdAvviaMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof putBackProcedimentiPraticaIdTipiProcedimentoIdAvvia>
    >
  >;

export type PutBackProcedimentiPraticaIdTipiProcedimentoIdAvviaMutationError =
  ErrorType<unknown>;

export const usePutBackProcedimentiPraticaIdTipiProcedimentoIdAvvia = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof putBackProcedimentiPraticaIdTipiProcedimentoIdAvvia>
    >,
    TError,
    { idIstanzaProcedimento: string; idTipoProcedimento: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPutBackProcedimentiPraticaIdTipiProcedimentoIdAvviaMutationOptions(
      options,
    );

  return useMutation(mutationOptions);
};
export const putBackProcedimentiPraticaIdSoggettiId = (
  idIstanzaPratica: string,
  idSoggettoPratica: string,
  personaFisicaRequestDTO: PersonaFisicaRequestDTO,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<PersonaFisicaRequestDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/pratica/${idIstanzaPratica}/soggetti/${idSoggettoPratica}`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: personaFisicaRequestDTO,
    },
    options,
  );
};

export const getPutBackProcedimentiPraticaIdSoggettiIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBackProcedimentiPraticaIdSoggettiId>>,
    TError,
    {
      idIstanzaPratica: string;
      idSoggettoPratica: string;
      data: PersonaFisicaRequestDTO;
    },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putBackProcedimentiPraticaIdSoggettiId>>,
  TError,
  {
    idIstanzaPratica: string;
    idSoggettoPratica: string;
    data: PersonaFisicaRequestDTO;
  },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putBackProcedimentiPraticaIdSoggettiId>>,
    {
      idIstanzaPratica: string;
      idSoggettoPratica: string;
      data: PersonaFisicaRequestDTO;
    }
  > = props => {
    const { idIstanzaPratica, idSoggettoPratica, data } = props ?? {};

    return putBackProcedimentiPraticaIdSoggettiId(
      idIstanzaPratica,
      idSoggettoPratica,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PutBackProcedimentiPraticaIdSoggettiIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putBackProcedimentiPraticaIdSoggettiId>>
>;
export type PutBackProcedimentiPraticaIdSoggettiIdMutationBody =
  PersonaFisicaRequestDTO;
export type PutBackProcedimentiPraticaIdSoggettiIdMutationError =
  ErrorType<unknown>;

export const usePutBackProcedimentiPraticaIdSoggettiId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBackProcedimentiPraticaIdSoggettiId>>,
    TError,
    {
      idIstanzaPratica: string;
      idSoggettoPratica: string;
      data: PersonaFisicaRequestDTO;
    },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPutBackProcedimentiPraticaIdSoggettiIdMutationOptions(options);

  return useMutation(mutationOptions);
};
export const deleteBackProcedimentiPraticaIdSoggettiId = (
  idIstanzaPratica: string,
  idSoggettoPratica: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<string>(
    {
      url: `/framework-bo-procedimenti/procedimenti/pratica/${idIstanzaPratica}/soggetti/${idSoggettoPratica}`,
      method: 'delete',
    },
    options,
  );
};

export const getDeleteBackProcedimentiPraticaIdSoggettiIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBackProcedimentiPraticaIdSoggettiId>>,
    TError,
    { idIstanzaPratica: string; idSoggettoPratica: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteBackProcedimentiPraticaIdSoggettiId>>,
  TError,
  { idIstanzaPratica: string; idSoggettoPratica: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteBackProcedimentiPraticaIdSoggettiId>>,
    { idIstanzaPratica: string; idSoggettoPratica: string }
  > = props => {
    const { idIstanzaPratica, idSoggettoPratica } = props ?? {};

    return deleteBackProcedimentiPraticaIdSoggettiId(
      idIstanzaPratica,
      idSoggettoPratica,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteBackProcedimentiPraticaIdSoggettiIdMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof deleteBackProcedimentiPraticaIdSoggettiId>>
  >;

export type DeleteBackProcedimentiPraticaIdSoggettiIdMutationError =
  ErrorType<unknown>;

export const useDeleteBackProcedimentiPraticaIdSoggettiId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBackProcedimentiPraticaIdSoggettiId>>,
    TError,
    { idIstanzaPratica: string; idSoggettoPratica: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getDeleteBackProcedimentiPraticaIdSoggettiIdMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Crea un nuovo allegato, a partire da un file del procedimento, ancora non associato a nessuna comunicazione
 */
export const postBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdFileProcedimento =
  (
    idIstanzaProcedimento: string,
    idTipoComunicazione: string,
    idTipoAllegato: string,
    elencoFileDocumento: ElencoFileDocumento,
    options?: SecondParameter<typeof apiClientRequest>,
  ) => {
    return apiClientRequest<CreaAllegatoResponse>(
      {
        url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/tipi-comunicazione/${idTipoComunicazione}/tipi-allegato/${idTipoAllegato}/file-procedimento`,
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        data: elencoFileDocumento,
      },
      options,
    );
  };

export const getPostBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdFileProcedimentoMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdFileProcedimento
        >
      >,
      TError,
      {
        idIstanzaProcedimento: string;
        idTipoComunicazione: string;
        idTipoAllegato: string;
        data: ElencoFileDocumento;
      },
      TContext
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof postBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdFileProcedimento
      >
    >,
    TError,
    {
      idIstanzaProcedimento: string;
      idTipoComunicazione: string;
      idTipoAllegato: string;
      data: ElencoFileDocumento;
    },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdFileProcedimento
        >
      >,
      {
        idIstanzaProcedimento: string;
        idTipoComunicazione: string;
        idTipoAllegato: string;
        data: ElencoFileDocumento;
      }
    > = props => {
      const {
        idIstanzaProcedimento,
        idTipoComunicazione,
        idTipoAllegato,
        data,
      } = props ?? {};

      return postBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdFileProcedimento(
        idIstanzaProcedimento,
        idTipoComunicazione,
        idTipoAllegato,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdFileProcedimentoMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof postBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdFileProcedimento
      >
    >
  >;
export type PostBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdFileProcedimentoMutationBody =
  ElencoFileDocumento;
export type PostBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdFileProcedimentoMutationError =
  ErrorType<unknown>;

export const usePostBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdFileProcedimento =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdFileProcedimento
        >
      >,
      TError,
      {
        idIstanzaProcedimento: string;
        idTipoComunicazione: string;
        idTipoAllegato: string;
        data: ElencoFileDocumento;
      },
      TContext
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  }) => {
    const mutationOptions =
      getPostBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdFileProcedimentoMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };
/**
 * Crea un nuovo allegato, ancora non associato a nessuna comunicazione
 */
export const postBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdAllegati = (
  idIstanzaProcedimento: string,
  idTipoComunicazione: string,
  idTipoAllegato: string,
  postBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdAllegatiBody: PostBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdAllegatiBody,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  const formData = new FormData();
  formData.append(
    'file',
    postBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdAllegatiBody.file,
  );

  return apiClientRequest<CreaAllegatoResponse>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/tipi-comunicazione/${idTipoComunicazione}/tipi-allegato/${idTipoAllegato}/allegati`,
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
    },
    options,
  );
};

export const getPostBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdAllegatiMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdAllegati
        >
      >,
      TError,
      {
        idIstanzaProcedimento: string;
        idTipoComunicazione: string;
        idTipoAllegato: string;
        data: PostBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdAllegatiBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof postBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdAllegati
      >
    >,
    TError,
    {
      idIstanzaProcedimento: string;
      idTipoComunicazione: string;
      idTipoAllegato: string;
      data: PostBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdAllegatiBody;
    },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdAllegati
        >
      >,
      {
        idIstanzaProcedimento: string;
        idTipoComunicazione: string;
        idTipoAllegato: string;
        data: PostBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdAllegatiBody;
      }
    > = props => {
      const {
        idIstanzaProcedimento,
        idTipoComunicazione,
        idTipoAllegato,
        data,
      } = props ?? {};

      return postBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdAllegati(
        idIstanzaProcedimento,
        idTipoComunicazione,
        idTipoAllegato,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdAllegatiMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof postBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdAllegati
      >
    >
  >;
export type PostBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdAllegatiMutationBody =
  PostBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdAllegatiBody;
export type PostBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdAllegatiMutationError =
  ErrorType<unknown>;

export const usePostBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdAllegati =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdAllegati
        >
      >,
      TError,
      {
        idIstanzaProcedimento: string;
        idTipoComunicazione: string;
        idTipoAllegato: string;
        data: PostBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdAllegatiBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  }) => {
    const mutationOptions =
      getPostBackProcedimentiIdTipiComunicazioneIdTipiAllegatoIdAllegatiMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };
export const getBackProcedimentiIdScadenze = (
  idIstanzaProcedimento: string,
  params?: GetBackProcedimentiIdScadenzeParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<WsRispostaPaginataListScadenzaDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/scadenze`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdScadenzeQueryKey = (
  idIstanzaProcedimento: string,
  params?: GetBackProcedimentiIdScadenzeParams,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/scadenze`,
    ...(params ? [params] : []),
  ] as const;

export const getGetBackProcedimentiIdScadenzeQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdScadenze>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  params?: GetBackProcedimentiIdScadenzeParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdScadenze>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdScadenze>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdScadenzeQueryKey(idIstanzaProcedimento, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdScadenze>>
  > = ({ signal }) =>
    getBackProcedimentiIdScadenze(
      idIstanzaProcedimento,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetBackProcedimentiIdScadenzeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdScadenze>>
>;
export type GetBackProcedimentiIdScadenzeQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiIdScadenze = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdScadenze>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  params?: GetBackProcedimentiIdScadenzeParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdScadenze>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdScadenzeQueryOptions(
    idIstanzaProcedimento,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postBackProcedimentiIdScadenze = (
  idIstanzaProcedimento: string,
  creaScadenzaRequest: CreaScadenzaRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<ScadenzaDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/scadenze`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: creaScadenzaRequest,
    },
    options,
  );
};

export const getPostBackProcedimentiIdScadenzeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackProcedimentiIdScadenze>>,
    TError,
    { idIstanzaProcedimento: string; data: CreaScadenzaRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackProcedimentiIdScadenze>>,
  TError,
  { idIstanzaProcedimento: string; data: CreaScadenzaRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackProcedimentiIdScadenze>>,
    { idIstanzaProcedimento: string; data: CreaScadenzaRequest }
  > = props => {
    const { idIstanzaProcedimento, data } = props ?? {};

    return postBackProcedimentiIdScadenze(
      idIstanzaProcedimento,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackProcedimentiIdScadenzeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackProcedimentiIdScadenze>>
>;
export type PostBackProcedimentiIdScadenzeMutationBody = CreaScadenzaRequest;
export type PostBackProcedimentiIdScadenzeMutationError = ErrorType<unknown>;

export const usePostBackProcedimentiIdScadenze = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackProcedimentiIdScadenze>>,
    TError,
    { idIstanzaProcedimento: string; data: CreaScadenzaRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackProcedimentiIdScadenzeMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackProcedimentiIdEndoprocedimentiIdAvvia = (
  idIstanzaProcedimento: string,
  idTipoProcedimento: string,
  creaEndoprocedimentoRequest: CreaEndoprocedimentoRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseAttivitaDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/endoprocedimenti/${idTipoProcedimento}/avvia`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: creaEndoprocedimentoRequest,
    },
    options,
  );
};

export const getPostBackProcedimentiIdEndoprocedimentiIdAvviaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackProcedimentiIdEndoprocedimentiIdAvvia>>,
    TError,
    {
      idIstanzaProcedimento: string;
      idTipoProcedimento: string;
      data: CreaEndoprocedimentoRequest;
    },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackProcedimentiIdEndoprocedimentiIdAvvia>>,
  TError,
  {
    idIstanzaProcedimento: string;
    idTipoProcedimento: string;
    data: CreaEndoprocedimentoRequest;
  },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackProcedimentiIdEndoprocedimentiIdAvvia>>,
    {
      idIstanzaProcedimento: string;
      idTipoProcedimento: string;
      data: CreaEndoprocedimentoRequest;
    }
  > = props => {
    const { idIstanzaProcedimento, idTipoProcedimento, data } = props ?? {};

    return postBackProcedimentiIdEndoprocedimentiIdAvvia(
      idIstanzaProcedimento,
      idTipoProcedimento,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackProcedimentiIdEndoprocedimentiIdAvviaMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postBackProcedimentiIdEndoprocedimentiIdAvvia>>
  >;
export type PostBackProcedimentiIdEndoprocedimentiIdAvviaMutationBody =
  CreaEndoprocedimentoRequest;
export type PostBackProcedimentiIdEndoprocedimentiIdAvviaMutationError =
  ErrorType<unknown>;

export const usePostBackProcedimentiIdEndoprocedimentiIdAvvia = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackProcedimentiIdEndoprocedimentiIdAvvia>>,
    TError,
    {
      idIstanzaProcedimento: string;
      idTipoProcedimento: string;
      data: CreaEndoprocedimentoRequest;
    },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackProcedimentiIdEndoprocedimentiIdAvviaMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackProcedimentiXlsx = (
  ricercaProcedimentoCsvRequest: RicercaProcedimentoCsvRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<string>(
    {
      url: `/framework-bo-procedimenti/procedimenti/xlsx`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: ricercaProcedimentoCsvRequest,
    },
    options,
  );
};

export const getPostBackProcedimentiXlsxMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackProcedimentiXlsx>>,
    TError,
    { data: RicercaProcedimentoCsvRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackProcedimentiXlsx>>,
  TError,
  { data: RicercaProcedimentoCsvRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackProcedimentiXlsx>>,
    { data: RicercaProcedimentoCsvRequest }
  > = props => {
    const { data } = props ?? {};

    return postBackProcedimentiXlsx(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackProcedimentiXlsxMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackProcedimentiXlsx>>
>;
export type PostBackProcedimentiXlsxMutationBody =
  RicercaProcedimentoCsvRequest;
export type PostBackProcedimentiXlsxMutationError = ErrorType<unknown>;

export const usePostBackProcedimentiXlsx = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackProcedimentiXlsx>>,
    TError,
    { data: RicercaProcedimentoCsvRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostBackProcedimentiXlsxMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackProcedimentiPraticaIdSubentro = (
  idIstanzaProcedimento: string,
  subentroDTO: SubentroDTO,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseAttivitaDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/pratica/${idIstanzaProcedimento}/subentro`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: subentroDTO,
    },
    options,
  );
};

export const getPostBackProcedimentiPraticaIdSubentroMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackProcedimentiPraticaIdSubentro>>,
    TError,
    { idIstanzaProcedimento: string; data: SubentroDTO },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackProcedimentiPraticaIdSubentro>>,
  TError,
  { idIstanzaProcedimento: string; data: SubentroDTO },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackProcedimentiPraticaIdSubentro>>,
    { idIstanzaProcedimento: string; data: SubentroDTO }
  > = props => {
    const { idIstanzaProcedimento, data } = props ?? {};

    return postBackProcedimentiPraticaIdSubentro(
      idIstanzaProcedimento,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackProcedimentiPraticaIdSubentroMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackProcedimentiPraticaIdSubentro>>
>;
export type PostBackProcedimentiPraticaIdSubentroMutationBody = SubentroDTO;
export type PostBackProcedimentiPraticaIdSubentroMutationError =
  ErrorType<unknown>;

export const usePostBackProcedimentiPraticaIdSubentro = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackProcedimentiPraticaIdSubentro>>,
    TError,
    { idIstanzaProcedimento: string; data: SubentroDTO },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackProcedimentiPraticaIdSubentroMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getBackProcedimentiPraticaIdSoggetti = (
  idIstanzaPratica: string,
  params?: GetBackProcedimentiPraticaIdSoggettiParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<PersonaFisicaRequestDTO[]>(
    {
      url: `/framework-bo-procedimenti/procedimenti/pratica/${idIstanzaPratica}/soggetti`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiPraticaIdSoggettiQueryKey = (
  idIstanzaPratica: string,
  params?: GetBackProcedimentiPraticaIdSoggettiParams,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/pratica/${idIstanzaPratica}/soggetti`,
    ...(params ? [params] : []),
  ] as const;

export const getGetBackProcedimentiPraticaIdSoggettiQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiPraticaIdSoggetti>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaPratica: string,
  params?: GetBackProcedimentiPraticaIdSoggettiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiPraticaIdSoggetti>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiPraticaIdSoggetti>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiPraticaIdSoggettiQueryKey(idIstanzaPratica, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiPraticaIdSoggetti>>
  > = ({ signal }) =>
    getBackProcedimentiPraticaIdSoggetti(
      idIstanzaPratica,
      params,
      requestOptions,
      signal,
    );

  return { queryKey, queryFn, enabled: !!idIstanzaPratica, ...queryOptions };
};

export type GetBackProcedimentiPraticaIdSoggettiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiPraticaIdSoggetti>>
>;
export type GetBackProcedimentiPraticaIdSoggettiQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiPraticaIdSoggetti = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiPraticaIdSoggetti>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaPratica: string,
  params?: GetBackProcedimentiPraticaIdSoggettiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiPraticaIdSoggetti>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiPraticaIdSoggettiQueryOptions(
    idIstanzaPratica,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postBackProcedimentiPraticaIdSoggetti = (
  idIstanzaPratica: string,
  personaFisicaRequestDTO: PersonaFisicaRequestDTO,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<PersonaFisicaRequestDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/pratica/${idIstanzaPratica}/soggetti`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: personaFisicaRequestDTO,
    },
    options,
  );
};

export const getPostBackProcedimentiPraticaIdSoggettiMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackProcedimentiPraticaIdSoggetti>>,
    TError,
    { idIstanzaPratica: string; data: PersonaFisicaRequestDTO },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackProcedimentiPraticaIdSoggetti>>,
  TError,
  { idIstanzaPratica: string; data: PersonaFisicaRequestDTO },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackProcedimentiPraticaIdSoggetti>>,
    { idIstanzaPratica: string; data: PersonaFisicaRequestDTO }
  > = props => {
    const { idIstanzaPratica, data } = props ?? {};

    return postBackProcedimentiPraticaIdSoggetti(
      idIstanzaPratica,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackProcedimentiPraticaIdSoggettiMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackProcedimentiPraticaIdSoggetti>>
>;
export type PostBackProcedimentiPraticaIdSoggettiMutationBody =
  PersonaFisicaRequestDTO;
export type PostBackProcedimentiPraticaIdSoggettiMutationError =
  ErrorType<unknown>;

export const usePostBackProcedimentiPraticaIdSoggetti = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackProcedimentiPraticaIdSoggetti>>,
    TError,
    { idIstanzaPratica: string; data: PersonaFisicaRequestDTO },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackProcedimentiPraticaIdSoggettiMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackProcedimentiGeojson = (
  ricercaProcedimentoCsvRequest: RicercaProcedimentoCsvRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<PostBackProcedimentiGeojson200>(
    {
      url: `/framework-bo-procedimenti/procedimenti/geojson`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: ricercaProcedimentoCsvRequest,
    },
    options,
  );
};

export const getPostBackProcedimentiGeojsonMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackProcedimentiGeojson>>,
    TError,
    { data: RicercaProcedimentoCsvRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackProcedimentiGeojson>>,
  TError,
  { data: RicercaProcedimentoCsvRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackProcedimentiGeojson>>,
    { data: RicercaProcedimentoCsvRequest }
  > = props => {
    const { data } = props ?? {};

    return postBackProcedimentiGeojson(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackProcedimentiGeojsonMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackProcedimentiGeojson>>
>;
export type PostBackProcedimentiGeojsonMutationBody =
  RicercaProcedimentoCsvRequest;
export type PostBackProcedimentiGeojsonMutationError = ErrorType<unknown>;

export const usePostBackProcedimentiGeojson = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackProcedimentiGeojson>>,
    TError,
    { data: RicercaProcedimentoCsvRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackProcedimentiGeojsonMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackProcedimentiCsv = (
  ricercaProcedimentoCsvRequest: RicercaProcedimentoCsvRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<string>(
    {
      url: `/framework-bo-procedimenti/procedimenti/csv`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: ricercaProcedimentoCsvRequest,
    },
    options,
  );
};

export const getPostBackProcedimentiCsvMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackProcedimentiCsv>>,
    TError,
    { data: RicercaProcedimentoCsvRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackProcedimentiCsv>>,
  TError,
  { data: RicercaProcedimentoCsvRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackProcedimentiCsv>>,
    { data: RicercaProcedimentoCsvRequest }
  > = props => {
    const { data } = props ?? {};

    return postBackProcedimentiCsv(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackProcedimentiCsvMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackProcedimentiCsv>>
>;
export type PostBackProcedimentiCsvMutationBody = RicercaProcedimentoCsvRequest;
export type PostBackProcedimentiCsvMutationError = ErrorType<unknown>;

export const usePostBackProcedimentiCsv = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackProcedimentiCsv>>,
    TError,
    { data: RicercaProcedimentoCsvRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostBackProcedimentiCsvMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getBackProcedimentiB2B = (
  params: GetBackProcedimentiB2BParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<IstanzaProcedimento[]>(
    {
      url: `/framework-bo-procedimenti/procedimenti/b2b`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiB2BQueryKey = (
  params: GetBackProcedimentiB2BParams,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/b2b`,
    ...(params ? [params] : []),
  ] as const;

export const getGetBackProcedimentiB2BQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiB2B>>,
  TError = ErrorType<unknown>,
>(
  params: GetBackProcedimentiB2BParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiB2B>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiB2B>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBackProcedimentiB2BQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiB2B>>
  > = ({ signal }) => getBackProcedimentiB2B(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetBackProcedimentiB2BQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiB2B>>
>;
export type GetBackProcedimentiB2BQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiB2B = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiB2B>>,
  TError = ErrorType<unknown>,
>(
  params: GetBackProcedimentiB2BParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiB2B>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiB2BQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postBackProcedimentiB2B = (
  postBackProcedimentiB2BBody: string[],
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<IstanzaProcedimento[]>(
    {
      url: `/framework-bo-procedimenti/procedimenti/b2b`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: postBackProcedimentiB2BBody,
    },
    options,
  );
};

export const getPostBackProcedimentiB2BMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackProcedimentiB2B>>,
    TError,
    { data: string[] },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackProcedimentiB2B>>,
  TError,
  { data: string[] },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackProcedimentiB2B>>,
    { data: string[] }
  > = props => {
    const { data } = props ?? {};

    return postBackProcedimentiB2B(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackProcedimentiB2BMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackProcedimentiB2B>>
>;
export type PostBackProcedimentiB2BMutationBody = string[];
export type PostBackProcedimentiB2BMutationError = ErrorType<unknown>;

export const usePostBackProcedimentiB2B = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackProcedimentiB2B>>,
    TError,
    { data: string[] },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostBackProcedimentiB2BMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getBackProcedimenti = (
  params?: GetBackProcedimentiParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<BEResponseRicercaProcedimentoResponseDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiQueryKey = (
  params?: GetBackProcedimentiParams,
) =>
  [
    `/framework-bo-procedimenti/procedimenti`,
    ...(params ? [params] : []),
  ] as const;

export const getGetBackProcedimentiQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimenti>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBackProcedimentiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimenti>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimenti>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBackProcedimentiQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimenti>>
  > = ({ signal }) => getBackProcedimenti(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetBackProcedimentiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimenti>>
>;
export type GetBackProcedimentiQueryError = ErrorType<unknown>;

export const useGetBackProcedimenti = <
  TData = Awaited<ReturnType<typeof getBackProcedimenti>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBackProcedimentiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimenti>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Estrae la cronologia completa del procedimento in formato CSV
 * @summary Export CSV cronologia procedimento
 */
export const getBackProcedimentiIdCronologiaExportCsv = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<string>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${id}/cronologia/export-csv`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdCronologiaExportCsvQueryKey = (
  id: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${id}/cronologia/export-csv`,
  ] as const;

export const getGetBackProcedimentiIdCronologiaExportCsvQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdCronologiaExportCsv>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdCronologiaExportCsv>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdCronologiaExportCsv>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdCronologiaExportCsvQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdCronologiaExportCsv>>
  > = ({ signal }) =>
    getBackProcedimentiIdCronologiaExportCsv(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetBackProcedimentiIdCronologiaExportCsvQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdCronologiaExportCsv>>
>;
export type GetBackProcedimentiIdCronologiaExportCsvQueryError =
  ErrorType<unknown>;

/**
 * @summary Export CSV cronologia procedimento
 */
export const useGetBackProcedimentiIdCronologiaExportCsv = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdCronologiaExportCsv>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdCronologiaExportCsv>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdCronologiaExportCsvQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiIdIsDeletable = (
  idTagSemantico: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<boolean>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idTagSemantico}/isDeletable`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdIsDeletableQueryKey = (
  idTagSemantico: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idTagSemantico}/isDeletable`,
  ] as const;

export const getGetBackProcedimentiIdIsDeletableQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdIsDeletable>>,
  TError = ErrorType<unknown>,
>(
  idTagSemantico: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdIsDeletable>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdIsDeletable>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdIsDeletableQueryKey(idTagSemantico);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdIsDeletable>>
  > = ({ signal }) =>
    getBackProcedimentiIdIsDeletable(idTagSemantico, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!idTagSemantico, ...queryOptions };
};

export type GetBackProcedimentiIdIsDeletableQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdIsDeletable>>
>;
export type GetBackProcedimentiIdIsDeletableQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiIdIsDeletable = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdIsDeletable>>,
  TError = ErrorType<unknown>,
>(
  idTagSemantico: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdIsDeletable>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdIsDeletableQueryOptions(
    idTagSemantico,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiIdDocumentoIdSezioniDocumentoIdHtml = (
  idProcedimento: string,
  idDocumento: string,
  idTipoSezione: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<string>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idProcedimento}/documento/${idDocumento}/sezioniDocumento/${idTipoSezione}/html`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdDocumentoIdSezioniDocumentoIdHtmlQueryKey =
  (idProcedimento: string, idDocumento: string, idTipoSezione: string) =>
    [
      `/framework-bo-procedimenti/procedimenti/${idProcedimento}/documento/${idDocumento}/sezioniDocumento/${idTipoSezione}/html`,
    ] as const;

export const getGetBackProcedimentiIdDocumentoIdSezioniDocumentoIdHtmlQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getBackProcedimentiIdDocumentoIdSezioniDocumentoIdHtml>
    >,
    TError = ErrorType<unknown>,
  >(
    idProcedimento: string,
    idDocumento: string,
    idTipoSezione: string,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBackProcedimentiIdDocumentoIdSezioniDocumentoIdHtml
          >
        >,
        TError,
        TData
      >;
      request?: SecondParameter<typeof apiClientRequest>;
    },
  ): UseQueryOptions<
    Awaited<
      ReturnType<typeof getBackProcedimentiIdDocumentoIdSezioniDocumentoIdHtml>
    >,
    TError,
    TData
  > & { queryKey: QueryKey } => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetBackProcedimentiIdDocumentoIdSezioniDocumentoIdHtmlQueryKey(
        idProcedimento,
        idDocumento,
        idTipoSezione,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getBackProcedimentiIdDocumentoIdSezioniDocumentoIdHtml
        >
      >
    > = ({ signal }) =>
      getBackProcedimentiIdDocumentoIdSezioniDocumentoIdHtml(
        idProcedimento,
        idDocumento,
        idTipoSezione,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(idProcedimento && idDocumento && idTipoSezione),
      ...queryOptions,
    };
  };

export type GetBackProcedimentiIdDocumentoIdSezioniDocumentoIdHtmlQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getBackProcedimentiIdDocumentoIdSezioniDocumentoIdHtml>
    >
  >;
export type GetBackProcedimentiIdDocumentoIdSezioniDocumentoIdHtmlQueryError =
  ErrorType<unknown>;

export const useGetBackProcedimentiIdDocumentoIdSezioniDocumentoIdHtml = <
  TData = Awaited<
    ReturnType<typeof getBackProcedimentiIdDocumentoIdSezioniDocumentoIdHtml>
  >,
  TError = ErrorType<unknown>,
>(
  idProcedimento: string,
  idDocumento: string,
  idTipoSezione: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getBackProcedimentiIdDocumentoIdSezioniDocumentoIdHtml
        >
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetBackProcedimentiIdDocumentoIdSezioniDocumentoIdHtmlQueryOptions(
      idProcedimento,
      idDocumento,
      idTipoSezione,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Scaricare tutti i documenti associati ad un procedimento in un archivio compresso organizzato in cartelle per tipologia di documento
 * @summary Scaricare tutti i documenti associati ad un procedimento in un archivio compresso organizzato in cartelle per tipologia di documento
 */
export const getBackProcedimentiIdZip = (
  idIstanzaProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<string>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/zip`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdZipQueryKey = (
  idIstanzaProcedimento: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/zip`,
  ] as const;

export const getGetBackProcedimentiIdZipQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdZip>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdZip>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdZip>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdZipQueryKey(idIstanzaProcedimento);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdZip>>
  > = ({ signal }) =>
    getBackProcedimentiIdZip(idIstanzaProcedimento, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetBackProcedimentiIdZipQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdZip>>
>;
export type GetBackProcedimentiIdZipQueryError = ErrorType<unknown>;

/**
 * @summary Scaricare tutti i documenti associati ad un procedimento in un archivio compresso organizzato in cartelle per tipologia di documento
 */
export const useGetBackProcedimentiIdZip = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdZip>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdZip>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdZipQueryOptions(
    idIstanzaProcedimento,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiIdTipiOggettiCollegati = (
  idIstanzaProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<OggettiCollegatiResponse>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/tipi-oggetti-collegati`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdTipiOggettiCollegatiQueryKey = (
  idIstanzaProcedimento: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/tipi-oggetti-collegati`,
  ] as const;

export const getGetBackProcedimentiIdTipiOggettiCollegatiQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdTipiOggettiCollegati>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdTipiOggettiCollegati>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdTipiOggettiCollegati>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdTipiOggettiCollegatiQueryKey(idIstanzaProcedimento);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdTipiOggettiCollegati>>
  > = ({ signal }) =>
    getBackProcedimentiIdTipiOggettiCollegati(
      idIstanzaProcedimento,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetBackProcedimentiIdTipiOggettiCollegatiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdTipiOggettiCollegati>>
>;
export type GetBackProcedimentiIdTipiOggettiCollegatiQueryError =
  ErrorType<unknown>;

export const useGetBackProcedimentiIdTipiOggettiCollegati = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdTipiOggettiCollegati>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdTipiOggettiCollegati>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdTipiOggettiCollegatiQueryOptions(
    idIstanzaProcedimento,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiIdTipiDomanda = (
  idIstanzaProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<PraticaDomandaDTO[]>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/tipi-domanda`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdTipiDomandaQueryKey = (
  idIstanzaProcedimento: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/tipi-domanda`,
  ] as const;

export const getGetBackProcedimentiIdTipiDomandaQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdTipiDomanda>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdTipiDomanda>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdTipiDomanda>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdTipiDomandaQueryKey(idIstanzaProcedimento);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdTipiDomanda>>
  > = ({ signal }) =>
    getBackProcedimentiIdTipiDomanda(
      idIstanzaProcedimento,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetBackProcedimentiIdTipiDomandaQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdTipiDomanda>>
>;
export type GetBackProcedimentiIdTipiDomandaQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiIdTipiDomanda = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdTipiDomanda>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdTipiDomanda>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdTipiDomandaQueryOptions(
    idIstanzaProcedimento,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiIdScadenzeId = (
  idIstanzaProcedimento: string,
  idScadenza: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<ScadenzaDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/scadenze/${idScadenza}`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdScadenzeIdQueryKey = (
  idIstanzaProcedimento: string,
  idScadenza: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/scadenze/${idScadenza}`,
  ] as const;

export const getGetBackProcedimentiIdScadenzeIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdScadenzeId>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  idScadenza: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdScadenzeId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdScadenzeId>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdScadenzeIdQueryKey(
      idIstanzaProcedimento,
      idScadenza,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdScadenzeId>>
  > = ({ signal }) =>
    getBackProcedimentiIdScadenzeId(
      idIstanzaProcedimento,
      idScadenza,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(idIstanzaProcedimento && idScadenza),
    ...queryOptions,
  };
};

export type GetBackProcedimentiIdScadenzeIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdScadenzeId>>
>;
export type GetBackProcedimentiIdScadenzeIdQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiIdScadenzeId = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdScadenzeId>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  idScadenza: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdScadenzeId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdScadenzeIdQueryOptions(
    idIstanzaProcedimento,
    idScadenza,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const deleteBackProcedimentiIdScadenzeId = (
  idIstanzaProcedimento: string,
  idScadenza: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<ScadenzaDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/scadenze/${idScadenza}`,
      method: 'delete',
    },
    options,
  );
};

export const getDeleteBackProcedimentiIdScadenzeIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBackProcedimentiIdScadenzeId>>,
    TError,
    { idIstanzaProcedimento: string; idScadenza: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteBackProcedimentiIdScadenzeId>>,
  TError,
  { idIstanzaProcedimento: string; idScadenza: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteBackProcedimentiIdScadenzeId>>,
    { idIstanzaProcedimento: string; idScadenza: string }
  > = props => {
    const { idIstanzaProcedimento, idScadenza } = props ?? {};

    return deleteBackProcedimentiIdScadenzeId(
      idIstanzaProcedimento,
      idScadenza,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteBackProcedimentiIdScadenzeIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteBackProcedimentiIdScadenzeId>>
>;

export type DeleteBackProcedimentiIdScadenzeIdMutationError =
  ErrorType<unknown>;

export const useDeleteBackProcedimentiIdScadenzeId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBackProcedimentiIdScadenzeId>>,
    TError,
    { idIstanzaProcedimento: string; idScadenza: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getDeleteBackProcedimentiIdScadenzeIdMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getBackProcedimentiIdOggettiCollegati = (
  idIstanzaProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<BEResponseProcedimentoConOggettiCollegati>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/oggettiCollegati`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdOggettiCollegatiQueryKey = (
  idIstanzaProcedimento: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/oggettiCollegati`,
  ] as const;

export const getGetBackProcedimentiIdOggettiCollegatiQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdOggettiCollegati>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdOggettiCollegati>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdOggettiCollegati>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdOggettiCollegatiQueryKey(idIstanzaProcedimento);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdOggettiCollegati>>
  > = ({ signal }) =>
    getBackProcedimentiIdOggettiCollegati(
      idIstanzaProcedimento,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetBackProcedimentiIdOggettiCollegatiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdOggettiCollegati>>
>;
export type GetBackProcedimentiIdOggettiCollegatiQueryError =
  ErrorType<unknown>;

export const useGetBackProcedimentiIdOggettiCollegati = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdOggettiCollegati>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdOggettiCollegati>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdOggettiCollegatiQueryOptions(
    idIstanzaProcedimento,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Esegue il download della versione PDF della sezione dati di una istanza tipo pagamento associata ad un procedimento
 * @summary download pdf del preventivo
 */
export const getBackProcedimentiIdIstanzeTipiPagamentoIdScaricaPreventivo = (
  idIstanzaProcedimento: string,
  idIstanzaTipoPagamento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<string>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/istanze-tipi-pagamento/${idIstanzaTipoPagamento}/scarica-preventivo`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdIstanzeTipiPagamentoIdScaricaPreventivoQueryKey =
  (idIstanzaProcedimento: string, idIstanzaTipoPagamento: string) =>
    [
      `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/istanze-tipi-pagamento/${idIstanzaTipoPagamento}/scarica-preventivo`,
    ] as const;

export const getGetBackProcedimentiIdIstanzeTipiPagamentoIdScaricaPreventivoQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getBackProcedimentiIdIstanzeTipiPagamentoIdScaricaPreventivo
      >
    >,
    TError = ErrorType<unknown>,
  >(
    idIstanzaProcedimento: string,
    idIstanzaTipoPagamento: string,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBackProcedimentiIdIstanzeTipiPagamentoIdScaricaPreventivo
          >
        >,
        TError,
        TData
      >;
      request?: SecondParameter<typeof apiClientRequest>;
    },
  ): UseQueryOptions<
    Awaited<
      ReturnType<
        typeof getBackProcedimentiIdIstanzeTipiPagamentoIdScaricaPreventivo
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey } => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetBackProcedimentiIdIstanzeTipiPagamentoIdScaricaPreventivoQueryKey(
        idIstanzaProcedimento,
        idIstanzaTipoPagamento,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getBackProcedimentiIdIstanzeTipiPagamentoIdScaricaPreventivo
        >
      >
    > = ({ signal }) =>
      getBackProcedimentiIdIstanzeTipiPagamentoIdScaricaPreventivo(
        idIstanzaProcedimento,
        idIstanzaTipoPagamento,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(idIstanzaProcedimento && idIstanzaTipoPagamento),
      ...queryOptions,
    };
  };

export type GetBackProcedimentiIdIstanzeTipiPagamentoIdScaricaPreventivoQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getBackProcedimentiIdIstanzeTipiPagamentoIdScaricaPreventivo
      >
    >
  >;
export type GetBackProcedimentiIdIstanzeTipiPagamentoIdScaricaPreventivoQueryError =
  ErrorType<unknown>;

/**
 * @summary download pdf del preventivo
 */
export const useGetBackProcedimentiIdIstanzeTipiPagamentoIdScaricaPreventivo = <
  TData = Awaited<
    ReturnType<
      typeof getBackProcedimentiIdIstanzeTipiPagamentoIdScaricaPreventivo
    >
  >,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  idIstanzaTipoPagamento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getBackProcedimentiIdIstanzeTipiPagamentoIdScaricaPreventivo
        >
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetBackProcedimentiIdIstanzeTipiPagamentoIdScaricaPreventivoQueryOptions(
      idIstanzaProcedimento,
      idIstanzaTipoPagamento,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiIdInfoTask = (
  idIstanzaProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<BEResponseListTaskProcedimento>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/infoTask`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdInfoTaskQueryKey = (
  idIstanzaProcedimento: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/infoTask`,
  ] as const;

export const getGetBackProcedimentiIdInfoTaskQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdInfoTask>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdInfoTask>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdInfoTask>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdInfoTaskQueryKey(idIstanzaProcedimento);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdInfoTask>>
  > = ({ signal }) =>
    getBackProcedimentiIdInfoTask(
      idIstanzaProcedimento,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetBackProcedimentiIdInfoTaskQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdInfoTask>>
>;
export type GetBackProcedimentiIdInfoTaskQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiIdInfoTask = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdInfoTask>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdInfoTask>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdInfoTaskQueryOptions(
    idIstanzaProcedimento,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiIdInfoGenerali = (
  idIstanzaProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<BEResponseProcedimentoConTask>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/infoGenerali`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdInfoGeneraliQueryKey = (
  idIstanzaProcedimento: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/infoGenerali`,
  ] as const;

export const getGetBackProcedimentiIdInfoGeneraliQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdInfoGenerali>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdInfoGenerali>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdInfoGenerali>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdInfoGeneraliQueryKey(idIstanzaProcedimento);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdInfoGenerali>>
  > = ({ signal }) =>
    getBackProcedimentiIdInfoGenerali(
      idIstanzaProcedimento,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetBackProcedimentiIdInfoGeneraliQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdInfoGenerali>>
>;
export type GetBackProcedimentiIdInfoGeneraliQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiIdInfoGenerali = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdInfoGenerali>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdInfoGenerali>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdInfoGeneraliQueryOptions(
    idIstanzaProcedimento,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiIdFile = (
  idIstanzaProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<ElencoFileDocumento[]>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/file`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdFileQueryKey = (
  idIstanzaProcedimento: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/file`,
  ] as const;

export const getGetBackProcedimentiIdFileQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdFile>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdFile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdFile>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdFileQueryKey(idIstanzaProcedimento);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdFile>>
  > = ({ signal }) =>
    getBackProcedimentiIdFile(idIstanzaProcedimento, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetBackProcedimentiIdFileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdFile>>
>;
export type GetBackProcedimentiIdFileQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiIdFile = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdFile>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdFile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdFileQueryOptions(
    idIstanzaProcedimento,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiIdFileDocumentoId = (
  idIstanzaProcedimento: string,
  idFile: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<string>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/fileDocumento/${idFile}`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdFileDocumentoIdQueryKey = (
  idIstanzaProcedimento: string,
  idFile: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/fileDocumento/${idFile}`,
  ] as const;

export const getGetBackProcedimentiIdFileDocumentoIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdFileDocumentoId>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  idFile: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdFileDocumentoId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdFileDocumentoId>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdFileDocumentoIdQueryKey(
      idIstanzaProcedimento,
      idFile,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdFileDocumentoId>>
  > = ({ signal }) =>
    getBackProcedimentiIdFileDocumentoId(
      idIstanzaProcedimento,
      idFile,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(idIstanzaProcedimento && idFile),
    ...queryOptions,
  };
};

export type GetBackProcedimentiIdFileDocumentoIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdFileDocumentoId>>
>;
export type GetBackProcedimentiIdFileDocumentoIdQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiIdFileDocumentoId = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdFileDocumentoId>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  idFile: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdFileDocumentoId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdFileDocumentoIdQueryOptions(
    idIstanzaProcedimento,
    idFile,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiIdFileAllegatoId = (
  idIstanzaProcedimento: string,
  idFile: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<string>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/fileAllegato/${idFile}`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdFileAllegatoIdQueryKey = (
  idIstanzaProcedimento: string,
  idFile: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/fileAllegato/${idFile}`,
  ] as const;

export const getGetBackProcedimentiIdFileAllegatoIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdFileAllegatoId>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  idFile: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdFileAllegatoId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdFileAllegatoId>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdFileAllegatoIdQueryKey(
      idIstanzaProcedimento,
      idFile,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdFileAllegatoId>>
  > = ({ signal }) =>
    getBackProcedimentiIdFileAllegatoId(
      idIstanzaProcedimento,
      idFile,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(idIstanzaProcedimento && idFile),
    ...queryOptions,
  };
};

export type GetBackProcedimentiIdFileAllegatoIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdFileAllegatoId>>
>;
export type GetBackProcedimentiIdFileAllegatoIdQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiIdFileAllegatoId = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdFileAllegatoId>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  idFile: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdFileAllegatoId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdFileAllegatoIdQueryOptions(
    idIstanzaProcedimento,
    idFile,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiIdEndoprocedimenti = (
  idIstanzaProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<BEResponseListProcedimento>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/endoprocedimenti`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdEndoprocedimentiQueryKey = (
  idIstanzaProcedimento: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/endoprocedimenti`,
  ] as const;

export const getGetBackProcedimentiIdEndoprocedimentiQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdEndoprocedimenti>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdEndoprocedimenti>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdEndoprocedimenti>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdEndoprocedimentiQueryKey(idIstanzaProcedimento);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdEndoprocedimenti>>
  > = ({ signal }) =>
    getBackProcedimentiIdEndoprocedimenti(
      idIstanzaProcedimento,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetBackProcedimentiIdEndoprocedimentiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdEndoprocedimenti>>
>;
export type GetBackProcedimentiIdEndoprocedimentiQueryError =
  ErrorType<unknown>;

export const useGetBackProcedimentiIdEndoprocedimenti = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdEndoprocedimenti>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdEndoprocedimenti>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdEndoprocedimentiQueryOptions(
    idIstanzaProcedimento,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiIdEndoprocedimentiPrimoLivello = (
  idIstanzaProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<string[]>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/endoprocedimenti-primo-livello`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdEndoprocedimentiPrimoLivelloQueryKey = (
  idIstanzaProcedimento: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/endoprocedimenti-primo-livello`,
  ] as const;

export const getGetBackProcedimentiIdEndoprocedimentiPrimoLivelloQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getBackProcedimentiIdEndoprocedimentiPrimoLivello>
    >,
    TError = ErrorType<unknown>,
  >(
    idIstanzaProcedimento: string,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<typeof getBackProcedimentiIdEndoprocedimentiPrimoLivello>
        >,
        TError,
        TData
      >;
      request?: SecondParameter<typeof apiClientRequest>;
    },
  ): UseQueryOptions<
    Awaited<
      ReturnType<typeof getBackProcedimentiIdEndoprocedimentiPrimoLivello>
    >,
    TError,
    TData
  > & { queryKey: QueryKey } => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetBackProcedimentiIdEndoprocedimentiPrimoLivelloQueryKey(
        idIstanzaProcedimento,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getBackProcedimentiIdEndoprocedimentiPrimoLivello>
      >
    > = ({ signal }) =>
      getBackProcedimentiIdEndoprocedimentiPrimoLivello(
        idIstanzaProcedimento,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!idIstanzaProcedimento,
      ...queryOptions,
    };
  };

export type GetBackProcedimentiIdEndoprocedimentiPrimoLivelloQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getBackProcedimentiIdEndoprocedimentiPrimoLivello>
    >
  >;
export type GetBackProcedimentiIdEndoprocedimentiPrimoLivelloQueryError =
  ErrorType<unknown>;

export const useGetBackProcedimentiIdEndoprocedimentiPrimoLivello = <
  TData = Awaited<
    ReturnType<typeof getBackProcedimentiIdEndoprocedimentiPrimoLivello>
  >,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof getBackProcedimentiIdEndoprocedimentiPrimoLivello>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetBackProcedimentiIdEndoprocedimentiPrimoLivelloQueryOptions(
      idIstanzaProcedimento,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Ottiene le competenze associate agli Uffici a loro volta associati al procedimento
 */
export const getBackProcedimentiIdCompetenze = (
  idIstanzaProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<Competenza[]>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/competenze`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdCompetenzeQueryKey = (
  idIstanzaProcedimento: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/competenze`,
  ] as const;

export const getGetBackProcedimentiIdCompetenzeQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdCompetenze>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdCompetenze>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdCompetenze>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdCompetenzeQueryKey(idIstanzaProcedimento);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdCompetenze>>
  > = ({ signal }) =>
    getBackProcedimentiIdCompetenze(
      idIstanzaProcedimento,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetBackProcedimentiIdCompetenzeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdCompetenze>>
>;
export type GetBackProcedimentiIdCompetenzeQueryError = ErrorType<unknown>;

/**
 * @summary Ottiene le competenze associate agli Uffici a loro volta associati al procedimento
 */
export const useGetBackProcedimentiIdCompetenze = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdCompetenze>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdCompetenze>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdCompetenzeQueryOptions(
    idIstanzaProcedimento,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiIdCollegamenti = (
  idIstanzaProcedimento: string,
  params?: GetBackProcedimentiIdCollegamentiParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<BEResponseWsRispostaPaginataListCollegamentoIstanzaDettaglioDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/collegamenti`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdCollegamentiQueryKey = (
  idIstanzaProcedimento: string,
  params?: GetBackProcedimentiIdCollegamentiParams,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/collegamenti`,
    ...(params ? [params] : []),
  ] as const;

export const getGetBackProcedimentiIdCollegamentiQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdCollegamenti>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  params?: GetBackProcedimentiIdCollegamentiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdCollegamenti>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdCollegamenti>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdCollegamentiQueryKey(idIstanzaProcedimento, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdCollegamenti>>
  > = ({ signal }) =>
    getBackProcedimentiIdCollegamenti(
      idIstanzaProcedimento,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetBackProcedimentiIdCollegamentiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdCollegamenti>>
>;
export type GetBackProcedimentiIdCollegamentiQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiIdCollegamenti = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdCollegamenti>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  params?: GetBackProcedimentiIdCollegamentiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdCollegamenti>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdCollegamentiQueryOptions(
    idIstanzaProcedimento,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiIdCampiSemantici = (
  idIstanzaProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<CampoSemanticoProcedimento[]>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/campiSemantici`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdCampiSemanticiQueryKey = (
  idIstanzaProcedimento: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/campiSemantici`,
  ] as const;

export const getGetBackProcedimentiIdCampiSemanticiQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdCampiSemantici>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdCampiSemantici>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdCampiSemantici>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdCampiSemanticiQueryKey(idIstanzaProcedimento);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdCampiSemantici>>
  > = ({ signal }) =>
    getBackProcedimentiIdCampiSemantici(
      idIstanzaProcedimento,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetBackProcedimentiIdCampiSemanticiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdCampiSemantici>>
>;
export type GetBackProcedimentiIdCampiSemanticiQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiIdCampiSemantici = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdCampiSemantici>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdCampiSemantici>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdCampiSemanticiQueryOptions(
    idIstanzaProcedimento,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiIdCampiSemanticiPratica = (
  idIstanzaProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<BEResponseListCampoSemanticoProcedimento>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/campi-semantici-pratica`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdCampiSemanticiPraticaQueryKey = (
  idIstanzaProcedimento: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/campi-semantici-pratica`,
  ] as const;

export const getGetBackProcedimentiIdCampiSemanticiPraticaQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getBackProcedimentiIdCampiSemanticiPratica>
  >,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdCampiSemanticiPratica>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdCampiSemanticiPratica>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdCampiSemanticiPraticaQueryKey(
      idIstanzaProcedimento,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdCampiSemanticiPratica>>
  > = ({ signal }) =>
    getBackProcedimentiIdCampiSemanticiPratica(
      idIstanzaProcedimento,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetBackProcedimentiIdCampiSemanticiPraticaQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdCampiSemanticiPratica>>
>;
export type GetBackProcedimentiIdCampiSemanticiPraticaQueryError =
  ErrorType<unknown>;

export const useGetBackProcedimentiIdCampiSemanticiPratica = <
  TData = Awaited<
    ReturnType<typeof getBackProcedimentiIdCampiSemanticiPratica>
  >,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdCampiSemanticiPratica>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetBackProcedimentiIdCampiSemanticiPraticaQueryOptions(
      idIstanzaProcedimento,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Ricerca delle fasi relative ad una istanza di Procedimento
 */
export const getBackProcedimentiIdAnagraficaFasi = (
  idIstanzaProcedimento: string,
  params?: GetBackProcedimentiIdAnagraficaFasiParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<AnagraficaFasiDTO[]>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/anagrafica-fasi`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdAnagraficaFasiQueryKey = (
  idIstanzaProcedimento: string,
  params?: GetBackProcedimentiIdAnagraficaFasiParams,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimento}/anagrafica-fasi`,
    ...(params ? [params] : []),
  ] as const;

export const getGetBackProcedimentiIdAnagraficaFasiQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdAnagraficaFasi>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  params?: GetBackProcedimentiIdAnagraficaFasiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdAnagraficaFasi>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiIdAnagraficaFasi>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiIdAnagraficaFasiQueryKey(
      idIstanzaProcedimento,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiIdAnagraficaFasi>>
  > = ({ signal }) =>
    getBackProcedimentiIdAnagraficaFasi(
      idIstanzaProcedimento,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetBackProcedimentiIdAnagraficaFasiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiIdAnagraficaFasi>>
>;
export type GetBackProcedimentiIdAnagraficaFasiQueryError = ErrorType<unknown>;

/**
 * @summary Ricerca delle fasi relative ad una istanza di Procedimento
 */
export const useGetBackProcedimentiIdAnagraficaFasi = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiIdAnagraficaFasi>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  params?: GetBackProcedimentiIdAnagraficaFasiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiIdAnagraficaFasi>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiIdAnagraficaFasiQueryOptions(
    idIstanzaProcedimento,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Restituisce gli uffici selezionabili per l'avvio di endoprocedimenti
 * @summary Restituisce gli uffici per avvio endoprocedimento
 */
export const getBackProcedimentiIdTipiEndoprocedimentoIdUffici = (
  idIstanzaProcedimentoPadre: string,
  idTipoEndoprocedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<TipoProcedimentoDettaglioUfficiAssociatiDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimentoPadre}/tipi-endoprocedimento/${idTipoEndoprocedimento}/uffici`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiIdTipiEndoprocedimentoIdUfficiQueryKey = (
  idIstanzaProcedimentoPadre: string,
  idTipoEndoprocedimento: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/${idIstanzaProcedimentoPadre}/tipi-endoprocedimento/${idTipoEndoprocedimento}/uffici`,
  ] as const;

export const getGetBackProcedimentiIdTipiEndoprocedimentoIdUfficiQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getBackProcedimentiIdTipiEndoprocedimentoIdUffici>
    >,
    TError = ErrorType<unknown>,
  >(
    idIstanzaProcedimentoPadre: string,
    idTipoEndoprocedimento: string,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<typeof getBackProcedimentiIdTipiEndoprocedimentoIdUffici>
        >,
        TError,
        TData
      >;
      request?: SecondParameter<typeof apiClientRequest>;
    },
  ): UseQueryOptions<
    Awaited<
      ReturnType<typeof getBackProcedimentiIdTipiEndoprocedimentoIdUffici>
    >,
    TError,
    TData
  > & { queryKey: QueryKey } => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetBackProcedimentiIdTipiEndoprocedimentoIdUfficiQueryKey(
        idIstanzaProcedimentoPadre,
        idTipoEndoprocedimento,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getBackProcedimentiIdTipiEndoprocedimentoIdUffici>
      >
    > = ({ signal }) =>
      getBackProcedimentiIdTipiEndoprocedimentoIdUffici(
        idIstanzaProcedimentoPadre,
        idTipoEndoprocedimento,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(idIstanzaProcedimentoPadre && idTipoEndoprocedimento),
      ...queryOptions,
    };
  };

export type GetBackProcedimentiIdTipiEndoprocedimentoIdUfficiQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getBackProcedimentiIdTipiEndoprocedimentoIdUffici>
    >
  >;
export type GetBackProcedimentiIdTipiEndoprocedimentoIdUfficiQueryError =
  ErrorType<unknown>;

/**
 * @summary Restituisce gli uffici per avvio endoprocedimento
 */
export const useGetBackProcedimentiIdTipiEndoprocedimentoIdUffici = <
  TData = Awaited<
    ReturnType<typeof getBackProcedimentiIdTipiEndoprocedimentoIdUffici>
  >,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimentoPadre: string,
  idTipoEndoprocedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof getBackProcedimentiIdTipiEndoprocedimentoIdUffici>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetBackProcedimentiIdTipiEndoprocedimentoIdUfficiQueryOptions(
      idIstanzaProcedimentoPadre,
      idTipoEndoprocedimento,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiTipi = (
  params?: GetBackProcedimentiTipiParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<BEResponseListTipologiaProcedimentoDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/tipi`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiTipiQueryKey = (
  params?: GetBackProcedimentiTipiParams,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/tipi`,
    ...(params ? [params] : []),
  ] as const;

export const getGetBackProcedimentiTipiQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiTipi>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBackProcedimentiTipiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiTipi>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiTipi>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBackProcedimentiTipiQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiTipi>>
  > = ({ signal }) => getBackProcedimentiTipi(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetBackProcedimentiTipiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiTipi>>
>;
export type GetBackProcedimentiTipiQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiTipi = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiTipi>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBackProcedimentiTipiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiTipi>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiTipiQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiTipiAvviabili = (
  params?: GetBackProcedimentiTipiAvviabiliParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<BEResponseListTipologiaProcedimentoDTO>(
    {
      url: `/framework-bo-procedimenti/procedimenti/tipiAvviabili`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiTipiAvviabiliQueryKey = (
  params?: GetBackProcedimentiTipiAvviabiliParams,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/tipiAvviabili`,
    ...(params ? [params] : []),
  ] as const;

export const getGetBackProcedimentiTipiAvviabiliQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiTipiAvviabili>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBackProcedimentiTipiAvviabiliParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiTipiAvviabili>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiTipiAvviabili>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiTipiAvviabiliQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiTipiAvviabili>>
  > = ({ signal }) =>
    getBackProcedimentiTipiAvviabili(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetBackProcedimentiTipiAvviabiliQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiTipiAvviabili>>
>;
export type GetBackProcedimentiTipiAvviabiliQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiTipiAvviabili = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiTipiAvviabili>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBackProcedimentiTipiAvviabiliParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiTipiAvviabili>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiTipiAvviabiliQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiPraticaIdUfficiCoinvolti = (
  idIstanzaProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<GetUfficioResponse[]>(
    {
      url: `/framework-bo-procedimenti/procedimenti/pratica/${idIstanzaProcedimento}/uffici-coinvolti`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiPraticaIdUfficiCoinvoltiQueryKey = (
  idIstanzaProcedimento: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/pratica/${idIstanzaProcedimento}/uffici-coinvolti`,
  ] as const;

export const getGetBackProcedimentiPraticaIdUfficiCoinvoltiQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getBackProcedimentiPraticaIdUfficiCoinvolti>
  >,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiPraticaIdUfficiCoinvolti>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiPraticaIdUfficiCoinvolti>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiPraticaIdUfficiCoinvoltiQueryKey(
      idIstanzaProcedimento,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiPraticaIdUfficiCoinvolti>>
  > = ({ signal }) =>
    getBackProcedimentiPraticaIdUfficiCoinvolti(
      idIstanzaProcedimento,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetBackProcedimentiPraticaIdUfficiCoinvoltiQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getBackProcedimentiPraticaIdUfficiCoinvolti>>
  >;
export type GetBackProcedimentiPraticaIdUfficiCoinvoltiQueryError =
  ErrorType<unknown>;

export const useGetBackProcedimentiPraticaIdUfficiCoinvolti = <
  TData = Awaited<
    ReturnType<typeof getBackProcedimentiPraticaIdUfficiCoinvolti>
  >,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiPraticaIdUfficiCoinvolti>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetBackProcedimentiPraticaIdUfficiCoinvoltiQueryOptions(
      idIstanzaProcedimento,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiPraticaIdPersoneFisiche = (
  idIstanzaProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<PersonaFisicaDTO[]>(
    {
      url: `/framework-bo-procedimenti/procedimenti/pratica/${idIstanzaProcedimento}/persone-fisiche`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiPraticaIdPersoneFisicheQueryKey = (
  idIstanzaProcedimento: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/pratica/${idIstanzaProcedimento}/persone-fisiche`,
  ] as const;

export const getGetBackProcedimentiPraticaIdPersoneFisicheQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getBackProcedimentiPraticaIdPersoneFisiche>
  >,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiPraticaIdPersoneFisiche>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiPraticaIdPersoneFisiche>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiPraticaIdPersoneFisicheQueryKey(
      idIstanzaProcedimento,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiPraticaIdPersoneFisiche>>
  > = ({ signal }) =>
    getBackProcedimentiPraticaIdPersoneFisiche(
      idIstanzaProcedimento,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetBackProcedimentiPraticaIdPersoneFisicheQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiPraticaIdPersoneFisiche>>
>;
export type GetBackProcedimentiPraticaIdPersoneFisicheQueryError =
  ErrorType<unknown>;

export const useGetBackProcedimentiPraticaIdPersoneFisiche = <
  TData = Awaited<
    ReturnType<typeof getBackProcedimentiPraticaIdPersoneFisiche>
  >,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiPraticaIdPersoneFisiche>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetBackProcedimentiPraticaIdPersoneFisicheQueryOptions(
      idIstanzaProcedimento,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Recupero tutti i campi potenzialmente estraibili in csv per i procedimenti/versione procedimenti pubblicati (per verticale)
 */
export const getBackProcedimentiGeojsonCampi = (
  params?: GetBackProcedimentiGeojsonCampiParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<CampoEstraibileCSV[]>(
    {
      url: `/framework-bo-procedimenti/procedimenti/geojson/campi`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiGeojsonCampiQueryKey = (
  params?: GetBackProcedimentiGeojsonCampiParams,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/geojson/campi`,
    ...(params ? [params] : []),
  ] as const;

export const getGetBackProcedimentiGeojsonCampiQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiGeojsonCampi>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBackProcedimentiGeojsonCampiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiGeojsonCampi>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiGeojsonCampi>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiGeojsonCampiQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiGeojsonCampi>>
  > = ({ signal }) =>
    getBackProcedimentiGeojsonCampi(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetBackProcedimentiGeojsonCampiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiGeojsonCampi>>
>;
export type GetBackProcedimentiGeojsonCampiQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiGeojsonCampi = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiGeojsonCampi>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBackProcedimentiGeojsonCampiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiGeojsonCampi>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiGeojsonCampiQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Recupero tutti i campi potenzialmente estraibili in csv per i procedimenti/versione procedimenti pubblicati (per verticale)
 */
export const getBackProcedimentiCsvCampi = (
  params?: GetBackProcedimentiCsvCampiParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<CampoEstraibileCSV[]>(
    {
      url: `/framework-bo-procedimenti/procedimenti/csv/campi`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiCsvCampiQueryKey = (
  params?: GetBackProcedimentiCsvCampiParams,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/csv/campi`,
    ...(params ? [params] : []),
  ] as const;

export const getGetBackProcedimentiCsvCampiQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiCsvCampi>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBackProcedimentiCsvCampiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiCsvCampi>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiCsvCampi>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBackProcedimentiCsvCampiQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiCsvCampi>>
  > = ({ signal }) =>
    getBackProcedimentiCsvCampi(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetBackProcedimentiCsvCampiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiCsvCampi>>
>;
export type GetBackProcedimentiCsvCampiQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiCsvCampi = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiCsvCampi>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBackProcedimentiCsvCampiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiCsvCampi>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiCsvCampiQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiB2BId = (
  idIstanzaProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<Procedimento>(
    {
      url: `/framework-bo-procedimenti/procedimenti/b2b/${idIstanzaProcedimento}`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiB2BIdQueryKey = (
  idIstanzaProcedimento: string,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/b2b/${idIstanzaProcedimento}`,
  ] as const;

export const getGetBackProcedimentiB2BIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiB2BId>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiB2BId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiB2BId>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackProcedimentiB2BIdQueryKey(idIstanzaProcedimento);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiB2BId>>
  > = ({ signal }) =>
    getBackProcedimentiB2BId(idIstanzaProcedimento, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetBackProcedimentiB2BIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiB2BId>>
>;
export type GetBackProcedimentiB2BIdQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiB2BId = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiB2BId>>,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiB2BId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiB2BIdQueryOptions(
    idIstanzaProcedimento,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackProcedimentiB2BSearch = (
  params?: GetBackProcedimentiB2BSearchParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<IstanzaProcedimento[]>(
    {
      url: `/framework-bo-procedimenti/procedimenti/b2b/search`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetBackProcedimentiB2BSearchQueryKey = (
  params?: GetBackProcedimentiB2BSearchParams,
) =>
  [
    `/framework-bo-procedimenti/procedimenti/b2b/search`,
    ...(params ? [params] : []),
  ] as const;

export const getGetBackProcedimentiB2BSearchQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiB2BSearch>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBackProcedimentiB2BSearchParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiB2BSearch>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackProcedimentiB2BSearch>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBackProcedimentiB2BSearchQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackProcedimentiB2BSearch>>
  > = ({ signal }) =>
    getBackProcedimentiB2BSearch(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetBackProcedimentiB2BSearchQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackProcedimentiB2BSearch>>
>;
export type GetBackProcedimentiB2BSearchQueryError = ErrorType<unknown>;

export const useGetBackProcedimentiB2BSearch = <
  TData = Awaited<ReturnType<typeof getBackProcedimentiB2BSearch>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBackProcedimentiB2BSearchParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackProcedimentiB2BSearch>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackProcedimentiB2BSearchQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
